/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    Breadcrumb, Button, Panel, Tab, Tabs,
    FloatingActionButton,
} from 'appkit-react';
import moment from 'moment';
import {
    useRef,
} from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import ReactFlow, {
    ReactFlowProvider,
} from 'react-flow-renderer';
import { scroller, animateScroll as scroll } from 'react-scroll';
import { useLocation } from 'react-router-dom';

import Loader from 'views/Shared/components/Loader';
import { GetFilesForProject, GetReconFunctions, GetSubProjects } from '../containers/Sidebar';
import ColumnsModal from './ColumnsModal';
import ConfigurationTabContainer from '../containers/ConfigurationTabContainer';
import CustomEdge from './CustomEdge';
import SpecialCustomNode from './SpecialCustomNode';
import DataPreviewTab from './DataPreviewTab';
import DefaultCustomNode from './DefaultCustomNode';
import InputCustomNode from './InputCustomNode';
import Sidebar from './Sidebar';
import ResetWarningModal from './ResetWarningModal';

const nodeTypes = {
    special: SpecialCustomNode,
    input: InputCustomNode,
    default: DefaultCustomNode,
};

const edgeTypes = {
    special: CustomEdge,
    input: CustomEdge,
    default: CustomEdge,
};

const getNodeElement = (type, position, nodeId, nodeName) => ({
    type,
    position,
    id: nodeId,
    data: {
        label: `${nodeName.fileDisplayName || nodeName.displayName || nodeName.projectName}`,
        fileName: nodeName.fileName,
        type: nodeName.functionName ? nodeName.functionName : '',
        projectId: nodeName.projectId ? nodeName.projectId : '',
        parentProjectId: nodeName.projectDisplayId ? nodeName.projectDisplayId.split('.')[0] : '',
        fileId: nodeName.fileId ? nodeName.fileId : null,
    },
});

const getColList = (nodeId, nodeName, filterFunctions) => ({
    id: nodeId,
    columns: nodeName.columnDetails ? nodeName.columnDetails.map(col => {
        const baseObj = {
            column: col.name,
            dataType: col.dataType,
            isChecked: false,
            filters: filterFunctions && filterFunctions.length > 0 && filterFunctions.map(fl => ({
                ...fl,
                displayName: fl.functionName.charAt(0).toUpperCase() + fl.functionName.slice(1),
                isSelected: false,
            })),
            operation: '',
        };
        if (col.dataType === 'date') {
            baseObj.start_date = '';
            baseObj.end_date = '';
        } else {
            baseObj.transformation = '';
        }
        return baseObj;
    }) : [],
    allChecked: false,
});

const getRunReconComponent = props => (
    <div className="a-h3">
        <span
            className="appkiticon icon-left-chevron-outline left-arrow-icon"
            onClick={() => props.navigateToDataLineageUpload()}
            role="button"
            tabIndex={0}
            onKeyDown={() => props.navigateToDataLineageUpload()}
        />
        Data Configuration
        <Button
            size="lg"
            kind="primary"
            style={{ float: 'right' }}
            isLoading={props.runLoading}
            disabled={props.shouldRunReconBtnDisable}
            onClick={props.onRun}
        >
            RUN RECONCILIATION
        </Button>
    </div>
);

const getResetBtnComponent = (resetConfig, isProjectConfigLoading) => (
    <Button
        size="md"
        kind="secondary"
        onClick={() => resetConfig()}
        disabled={isProjectConfigLoading}
    >
        Reset
    </Button>
);
const getRestoreBtnComponent = (showRestoreBtn, onRestore, isProjectConfigLoading, elements, resetConfig) => {
    if (showRestoreBtn) {
        return (
            <Button
                size="md"
                kind="secondary"
                onClick={onRestore}
                disabled={isProjectConfigLoading}
            >
                Restore
            </Button>
        );
    }
    return elements.length > 0 ? getResetBtnComponent(resetConfig, isProjectConfigLoading) : null;
};

const DataConfig = props => {
    const {
        reactFlowInstance, elements, setElements,
        selectedNode, nodeName, setNodeName, showColumnsModal,
        setShowColumnsModal, onConnect, onElementsRemove, onElementClick, onLoad,
        onDragOver, success, saveConfig, onSave, onRun, resetConfig, onRestore,
        onHandleChange, colsData, error, onFilterChange, onOperationChange, projectConfig,
        navigateToDataLineageUpload, breadCrumbItems, showAlert, onSaveConfig,
        runLoading, getId, filterFunctions, isProjectConfigLoading, setError,
        showWarningModal, setShowWarningModal, setConfirmReset, setShowAlert, setColsData,
    } = props;
    const location = useLocation();
    const { projectId } = location.state;

    /* function to fetch files of the selected project */
    const { getFilesForProject, isFileLoading, handleClick } = GetFilesForProject(projectId);

    /* function to fetch reconFunctions */
    const { reconFunctions, isFunctionLoading } = GetReconFunctions();

    /* function to fetch sub projects of the selected project */
    const { subProjects: { childProjConfig }, isSubProjectLoading } = GetSubProjects(projectId);
    const reactFlowWrapper = useRef(null);

    const shouldRunReconBtnDisable = projectConfig.reconRunStatus === 'IN PROGRESS' || isProjectConfigLoading || Object.keys(saveConfig).length === 0;

    const showRestoreBtn = Object.keys(saveConfig).length === 0 && projectConfig.flowConfig && elements.length === 0;

    /* function called when element is dragged and drop to Config panel */
    const onDrop = event => {
        const nodeId = getId();
        event.preventDefault();
        const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
        const type = event.dataTransfer.getData('application/reactflow');
        const position = reactFlowInstance.project({
            x: event.clientX - reactFlowBounds.left,
            y: event.clientY - reactFlowBounds.top,
        });
        const newNode = getNodeElement(type, position, nodeId, nodeName);
        if (type === 'input') {
            const colList = getColList(nodeId, nodeName, filterFunctions);
            setColsData(cl => cl.concat(colList));
        }
        setElements(es => es.concat(newNode));
        setConfirmReset(false);
    };

    /* function called when element is selected */
    const onElementSelect = (event, element) => {
        onElementClick(event, element);
        scroller.scrollTo('config-section', {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
        });
    };

    const reconBtnProps = {
        navigateToDataLineageUpload, runLoading, onRun, shouldRunReconBtnDisable,
    };

    return (
        <div className="true-comply-datarecon-config-page-layout">
            <div className="true-comply-datarecon-config-page">
                <Breadcrumb items={breadCrumbItems} />
                <div>
                    {error && showAlert && (
                        <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>{error.message}</Alert>
                    )}
                    {success && !error && showAlert && (
                        <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>{success.message}</Alert>
                    )}
                </div>
                {getRunReconComponent(reconBtnProps)}
                <ReactFlowProvider>
                    <Row>
                        <Col md={3}>
                            <Sidebar
                                setNodeName={setNodeName}
                                uploadFile={getFilesForProject}
                                isFileLoading={isFileLoading}
                                handleClick={handleClick}
                                isFunctionLoading={isFunctionLoading}
                                reconFunctions={reconFunctions}
                                isSubProjectLoading={isSubProjectLoading}
                                subProjects={childProjConfig}
                            />
                        </Col>
                        <Col md={9}>
                            <Panel
                                style={{ marginTop: '1rem' }}
                                title="CONFIGURATION PANEL"
                                className="a-increase-child-color-level-by-1"
                                renderRight={() => (
                                    <Row style={{ width: '28rem' }}>
                                        <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <div className="save__controls">
                                                {projectConfig.updated_date && (
                                                    <span className="a-h6" style={{ paddingTop: '0.4rem', paddingRight: '0.5rem' }}>
                                                        Last saved at:
                                                        {' '}
                                                        <span className="a-h6" style={{ fontWeight: 'initial' }}>
                                                            {moment(projectConfig && projectConfig.updatedAt).format('MM-DD-YYYY hh:mm A')}
                                                        </span>

                                                    </span>
                                                )}
                                                <Button
                                                    size="md"
                                                    kind="secondary"
                                                    onClick={onSave}
                                                    disabled={isProjectConfigLoading || Object.keys(elements).length === 0}
                                                >
                                                    Save
                                                </Button>
                                                {
                                                    getRestoreBtnComponent(showRestoreBtn, onRestore, isProjectConfigLoading, elements, resetConfig)
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            >
                                {isProjectConfigLoading && (
                                    <Loader />
                                )}
                                <div className="reactflow-wrapper" ref={reactFlowWrapper}>
                                    <ReactFlow
                                        elements={elements}
                                        onConnect={onConnect}
                                        onElementsRemove={onElementsRemove}
                                        onLoad={onLoad}
                                        onDrop={onDrop}
                                        onDragOver={onDragOver}
                                        onElementClick={onElementSelect}
                                        nodeTypes={nodeTypes}
                                        edgeTypes={edgeTypes}
                                        key="edges"
                                    />
                                </div>
                            </Panel>
                            <Panel
                                style={{ marginTop: '1.8rem' }}
                                className="config-section"
                            >
                                <Tabs defaultValue="1" className="a-tab-item-padding-10 true-comply-datarecon__tabs">
                                    <Tab value="1" label="CONFIGURATIONS">
                                        {Object.keys(selectedNode).length > 0 && (
                                            <>
                                                <ConfigurationTabContainer
                                                    selectedNode={selectedNode}
                                                    columnsData={colsData}
                                                    setShowColumnsModal={setShowColumnsModal}
                                                    showColumnsModal={showColumnsModal}
                                                    onSaveData={onSaveConfig}
                                                    elements={elements}
                                                    saveConfig={saveConfig}
                                                    onFilterChange={onFilterChange}
                                                    onOperationChange={onOperationChange}
                                                    subProjects={childProjConfig}
                                                    projectId={projectId}
                                                    error={error}
                                                    setError={setError}
                                                />
                                            </>
                                        )}
                                    </Tab>
                                    <Tab value="2" label="DATA PREVIEW">
                                        {Object.keys(selectedNode).length > 0 && (
                                            <>
                                                <DataPreviewTab
                                                    selectedNode={selectedNode}
                                                    setShowColumnsModal={setShowColumnsModal}
                                                    showColumnsModal={showColumnsModal}
                                                    projectId={projectId}
                                                />
                                            </>
                                        )}
                                    </Tab>
                                </Tabs>
                            </Panel>
                            <div style={{
                                position: 'fixed',
                                right: 10,
                                bottom: 0,
                                zIndex: 4,
                            }}
                            >
                                <FloatingActionButton kind="primary" onClick={() => scroll.scrollToTop()}>
                                    <span className="appkiticon a-btn-icon icon-up-chevron-fill" />
                                </FloatingActionButton>
                            </div>
                        </Col>
                    </Row>
                </ReactFlowProvider>
            </div>
            {showColumnsModal && (
                <ColumnsModal
                    showColumnsModal={showColumnsModal}
                    setShowColumnsModal={setShowColumnsModal}
                    onHandleChange={onHandleChange}
                    selectedNode={selectedNode}
                    colsData={colsData}
                />
            )}
            {showWarningModal && (
                <ResetWarningModal
                    showWarningModal={showWarningModal}
                    setShowWarningModal={setShowWarningModal}
                    setConfirmReset={setConfirmReset}
                />
            )}
        </div>
    );
};

export default DataConfig;
